import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { LAYOUT_TYPES } from '../../../constants';
import LineTitleGray from '../../atoms/titles/LineTitleGray';
import LinkButton from '../../atoms/button/LinkButton';
import { setCurrentStep, setLayoutType } from '../../../modules/app';
import { useQueryParams } from '../../../utils/queryParams';
import { RtoasterOnComplete } from '../../Head';

const Completed = ({ session }) => {
  const dispatch = useDispatch();
  const query = useQueryParams();
  const { m: memberNumber } = query;

  useEffect(() => {
    dispatch(
      setLayoutType(LAYOUT_TYPES.step)
    );
    dispatch(setCurrentStep(5));

    return () => {
      dispatch(
        setLayoutType(LAYOUT_TYPES.default)
      );
    };
  }, []);

  const pcView = window.innerWidth > 768;
  const rtoasterLabel1 = pcView ? 'rt_pc_kokunai_complete_01' : 'rt_sp_kokunai_complete_01';
  const rtoasterLabel2 = pcView ? 'rt_pc_kokunai_complete_02' : 'rt_sp_kokunai_complete_02';

  const handleMyPage = () => {
    const mypageLink = 'https://mbr.nta.co.jp/ecsystem_portal/view/mypage/mypageTop.html';
    window.open(mypageLink, '_blank');
  };

  return (
    <React.Fragment>
      <RtoasterOnComplete session={session} reservationId={memberNumber} />
      <div className="pageConfirmed">
        <LineTitleGray size="lg">お申込完了</LineTitleGray>
        <div className="confirmedBody">
          <p className="textGray">お申込みありがとうございます。</p>
          <p className="textRed">ご登録のメールアドレスに受付完了メールが自動配信されておりますのでご確認ください。</p>
          <p className="textGray">※メールが届かない場合はマイページの「お問い合わせ一覧」でもご確認いただけます。「ご登録のメールアドレスが誤っている」、「メール設定により届かない」、「プロモーションフォルダに入っている」、「ストレージの上限を超過している」などの理由が考えられますので、今一度ご確認をお願いいたします。</p>
          <p className="textGray">【ご案内】<br />取引条件説明書の記載事項を持って、契約の内容とさせていただきます。</p>
          <div className="inquiryNumberBlock">
            <div className="title">予約番号</div>
            <div className="number">{memberNumber}</div>
          </div>
          <div className="supTexts">
            <p className="supTextStrong">お申込み内容の確認・お問い合わせ（ご連絡事項）・eチケットお客様控えはこちらから</p>
          </div>
          <div className="linkActions">
            <div className="linkMypage">
              <LinkButton buttonType="cta" onClick={handleMyPage}>マイページへ</LinkButton>
            </div>
          </div>
        </div>
      </div>
      <div id={rtoasterLabel1} />
      <div id={rtoasterLabel2} />
    </React.Fragment>
  );
};

Completed.propTypes = {
  session: PropTypes.object,
};

export default Completed;
